
import './App.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle"
import Home from './components/Home';
import {
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import About from './components/About';
import Contact from './components/Contact';
import Services from './components/Services';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar/>
        <Switch>
          <Route exact path="/about">
            <About />
          </Route>
          <Route exact path="/services">
            <Services />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
            <Route exact path="/contact">
            <Contact/>
          </Route>
          <Redirect to="/"/>
        </Switch>

        <Footer/>

    </div>
  );
}

export default App;
